import { gql } from "gql";

export const GET_POSTS_FOR_MODERATION = gql(/* GraphQL */ `
  query GetPostsForModeration(
    $filter: PostModerationFilter
    $page: PageRequest
  ) {
    getPostsForModeration(filter: $filter, page: $page) {
      content {
        ...PostCard
      }
      total
    }
  }
`);
